import { useEffect, useState } from 'react'

let _setError: ((error: any) => void) | undefined

export const setGlobalError = (error: any) => {
  if (typeof _setError === 'function') {
    try {
      _setError(error)
    } catch (error) {
      console.error('Setting global error failed:')
      console.error(error)
    }
  }
}

const useGlobalError = (initialError?: any): [any, (error: any) => void] => {
  const [error, setError] = useState(initialError)
  _setError = setError

  useEffect(() => {
    if (initialError && initialError !== error) {
      setError(initialError)
    }
  }, [initialError])

  return [error, setError]
}

export default useGlobalError
